import { withProfiler, ErrorBoundary } from "@sentry/react"
import ThemeProviderWithLocalStorage from "@/v2-ui/theme/ThemeProviderWithLocalStorage"
import Toaster from "@/v2-ui/toaster"
import Tooltip from "@/v2-ui/tooltip"
import { ConfirmationProvider, ConfirmationDialog } from "@/v2-ui/confirmation"
import { getSystemTheme } from "@/v2-ui/theme/theme.utils"
import AppRouter from "@/v2-backoffice-client/app/AppRouter"
import ApolloProvider from "@/v2-backoffice-client/apollo/ApolloProvider"
import ErrorFallback from "@/v2-backoffice-client/ErrorFallback"

function App() {
  return (
    <ErrorBoundary showDialog fallback={ErrorFallback}>
      <ThemeProviderWithLocalStorage defaultTheme={getSystemTheme()}>
        <ApolloProvider>
          <Tooltip.Provider>
            <ConfirmationProvider>
              <Toaster />
              <ConfirmationDialog />
              <AppRouter />
            </ConfirmationProvider>
          </Tooltip.Provider>
        </ApolloProvider>
      </ThemeProviderWithLocalStorage>
    </ErrorBoundary>
  )
}

export default withProfiler(App)
